import { CSSObject, FlexProps } from '@chakra-ui/react';

export const transactionInfoFlexProps: FlexProps = {
  color: 'white',
};

export const TableText = ({ textVariation }: any): CSSObject => ({
  color: textVariation === 'positive' ? 'green.400' : 'white',
});
